/***
**Module Name: client
 **File Name :  client.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains clients table details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import { useNavigate, Link, useLocation } from "react-router-dom";
import moment from "moment";
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import TableLoader from "../../components/tableLoader";

import { contentContext } from "../../context/contentContext";
import * as Config from "../../constants/Config";
import SweetAlert from 'react-bootstrap-sweetalert';
import SessionPopup from "../SessionPopup"
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import ReactFileReader from 'react-file-reader';
const csv = require('csvtojson')
let { lambda, country, appname } = window.app;


const Client = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    // const [toggle, setToggle] = useState(false);
    const [content, setContent] = useState("");
    const [perpage, setPerpage] = useState(10);
    const [loaderEnable, setLoaderEnable] = useState(false);
    // const [data, setData] = useState([]);
    const [phoneError, setPhoneError] = useState('');
    const [clientId, setClientId] = useState("");
    const [isDelete, setIsDelete] = useState(false)
    const [countries, setCountries] = useState('');
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [image, setImg] = useState('');
    const [flag, setFlag] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);

    const [popup, setShowPopup] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    const handleClosePopup = () => setShowPopup(false);
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [config, setConfig] = useState({});
    const [subscriptionsData, setSubscriptionsData] = useState([]);
    const [importSuccess, setImportSuccess] = useState(false);

    const [importFailed, setImportFailed] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [headersFound, setHeaders] = useState([]);
    const [isErrorPopup, setErrorPopup] = useState(false);
    const [errorData, setErrorData] = useState([]);

    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, sortTableAlpha, arrow, sortTableByDate, userData, clientmanagesearch, setClientMangeSearch, clientAdvSearch, setClientAdvSearch, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setActiveMenuObj, activeMenuObj, processObject, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Clients")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    const prevRoute = usePrevious(route)

    const uploadFilesJson = [{
        heading: 'Sample Client Import', name: 'Client', downloadtemplate: config?.common?.resourcesCloudfront + appname + '/resources/clientImport.xlsx',
        headers: ["businessname", "contactname", "emailId", "phone", "subscription", "plantype", "commissionpercentage", "settlement", "businessaddress",]
    }];
    console.log('uploadFilesJson', uploadFilesJson)
    useEffect(() => {
        if (window.site) {
            setConfig(window.site);

        }

    }, [window.site]);
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            // setClientAdvSearch({})
            setSearchedFlag(false);
            setClientMangeSearch("");
        }

    }, [prevRoute]);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);

    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [

        {
            name: 'Business Name',
            selector: row => row?.businessname ?? "",
            sortable: true,
        },
        {
            name: 'Contact Name',
            selector: row => row?.contactname ?? "",
            sortable: true,
        },

        // {
        //     name: 'Type',
        //     selector: row => row?.type ?? "",
        //     sortable: true,
        // },
        {
            name: 'Subscription',
            selector: row => row?.subscription ?? "",
            sortable: true,
        },
        {
            name: 'EmailId',
            selector: row => row?.emailId ?? "",
            sortable: true,
        },
        {
            name: 'Phone Number',
            selector: row => row?.phone
                ?? "",
            sortable: true,
        },
        // {
        //     name: 'ACCOUNT MANAGER',
        //     // selector: row => row && row.companydetails && row.companydetails[0] && row.companydetails[0].accountmanager && row?.companydetails[0]?.accountmanager && row?.companydetails[0]?.accountmanager !== undefined && row?.companydetails[0]?.accountmanager !== "" ? row?.companydetails[0]?.accountmanager : "",
        //     selector: row => row?.companydetails?.[0]?.accountmanager ?? '',

        //     sortable: true,
        // },
        // {
        //     name: 'Entity',
        //     selector: row => row?.entity ?? "",
        //     sortable: true,
        // },
        {
            name: 'Created on',
            selector: row => row?.created,
            sortable: true,
            cell: (props) => props.created ? moment.utc(props.created).format("MM-DD-YYYY") : "",
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },

        {
            name:
                //  <>
                // {(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 
                // 'Actions' : null}</>
                'Actions'
            ,
            cell: (props) =>
                //  {
                subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
                <div className="d-flex">
                    {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
                        <a onClick={e => handleViewClient(e, props.clientid)}
                            className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}

                        // className={` text-success action-button`}
                        id="client-view-icon"><i className="mdi mdi-eye font-size-18"></i></a>
                    }
                    {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true &&
                        <a onClick={e => handleEditClient(e, props.clientid)} style={{ position: "inherit" }}
                            className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}
                        // className={`text-danger action-button`}
                        id="client-edit-icon"><i className="mdi mdi-pencil font-size-18"></i></a>
                    }
                    {/* {localStorage.getItem("clientid")===props?.clientid?} */}
                    <a style={{ position: "inherit" }}
                        onClick={() => handleDelete(props?.clientid)}
                        // className={`${subValDashboard && subValDashboard.delete && subValDashboard.delete.enable === false ? 'pe-none' : ''} text-danger action-button`}
                        className={`text-danger action-button ${localStorage.getItem("clientid") === props?.clientid || props?.status === "ARCHIVE" ? "pe-none" : ""}`}
                        id="client-delete-icon"><i className="mdi mdi-delete font-size-18"></i></a>
                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const getSbscriptionsApi = (e) => {
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/getSubscriptions?appname=' + appname + '&token=' + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setSubscriptionsData(response?.data?.result);
                    //setSelectedPlan("basic plan")


                }

            }).catch((err) => {
                console.log('error', err);

            });
    }
    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };

    const handleShowPopup = () => {
        GetTimeActivity()
        setShowPopup(true);
        getSbscriptionsApi();
    };

    const handleClick = (event) => {
        GetTimeActivity()
        setCurrentPage(Number(event.target.id));
    };


    // console.log('subValDashboard obj',subValDashboard)
    // const handleEditClient = (e,id) => {  
    //     navigate("/editclient/" + id);
    //  }

    const pages = [];
    for (let i = 1; i <= Math.ceil(content.totalClients / itemsPerPage); i++) {
        pages.push(i);
    }





    useEffect(() => {

        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setRoute("client")
        setActiveMenuId(200001)

        // setActiveMenuObj({
        //     "Client Management": true,
        //     "Contact Management": false,
        //     "Reports": false
        // })
        // if (search === true) {
        //     handleSearch();

        // } else {
        //     client();
        //   //   GetCountries();
        // }
        userActivity();

    }, []);


    // console.log('datataatatatta',data)

    const handleExport = () => {
        //    console.log('exportExcelData',global.exportExcelData)
        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "BUSINESS NAME": each?.businessname ?? "",
            "Subscription": each?.subscription ?? "",
            "EMAIL": each?.emailId ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            // "ACCOUNT MANAGER": each?.companydetails?.[0]?.accountmanager ?? "",
            // "ENTITY": each?.entity,
            "CREATED ON": each?.created ? new Date(each?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",
            "STATUS": each?.status ?? "",
        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data, `ClientsData.xlsx`);
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators

            const aField = String(selector(rowA)).toLowerCase();
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // setSortedData2(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    const Validate = () => {
        GetTimeActivity();
        let formIsValid = true;



        if (!clientAdvSearch?.phone?.trim()) {
            setPhoneError("Enter phone number");
            setTimeout(() => setPhoneError(""), 3000);
            formIsValid = false;
        } else
            if (
                (clientAdvSearch.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(clientAdvSearch.phone)) ||
                (clientAdvSearch.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(clientAdvSearch.phone))
            ) {
                setPhoneError("Invalid phone number format");
                setTimeout(() => setPhoneError(""), 3000);
                formIsValid = false;
            }
        return formIsValid;
    };
    useEffect(() => {


        console.log("trueeeeeeeeee", searchedFlag);
        if (searchedFlag) {
            console.log("came")
            handleSearch();
        } else {
            console.log("called get all deals")
            client();
            //   GetCountries();
        }

    }, [searchedFlag]);
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });


            setCountries(response?.result.data);
            const usaCountry = response?.result.data.filter(
                eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
            );


            // console.log('responseresponseresponse',response?.result.data)
            // await axios({
            //     method: 'GET',
            //     url: "https://d4nv8o5tzs3mt.cloudfront.net/",
            // })
            //     .then(function (response2) {
            //         console.log('response2',response2)
            //       // let locData = JSON.stringify(response?.data)
            //       let temp = response2.data.headers['cloudfront-viewer-country'][0].value
            //       console.log('temp',temp)
            //       setDefaultCountryCode(temp)

            //       let k = response && response?.result && response?.result.data && response?.result.data.length>0 && response?.result.data.filter(eachItem=>eachItem.alpha2.trim()===temp)

            //       if (id===undefined) {
            //         setIdc(k[0].alpha3)
            //         let newUser = Object.assign({}, editUser);
            //         setEditUser({ ...newUser, ['idc']: k[0].alpha3 });
            //       }



            //     });

        } catch {
            console.log("error");
        }
    };

    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state

        setClientAdvSearch((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));

    };
    const client = (e) => {
        console.log('client call')
        GetTimeActivity()
        let page = 1;
        //  setCurrentPage(1);
        setIsLoading(true);
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + '/clients?appname=' + appname + "&userid=" + userid + "&token=" + token,
        })
            .then(function (response) {
                // console.log("response", response?.data?.result?.data);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setData(response?.data?.result?.data);
                    global.exportExcelData = response?.data?.result?.data

                    setContent(response?.data?.result);
                    setIsLoading(false);
                    setClientMangeSearch("");
                    setSearchedFlag(false);
                }

            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }




    const handleAdd = () => {
        GetTimeActivity()
        navigate("/addclient")
    }
    const handleSearch = (e, flagggg) => {
        GetTimeActivity()



        setFlag(true)
        if (flagggg === "normalsearch" || flagggg === "click") {
            setSearchedFlag(true)
        }

        if (clientmanagesearch === "" && clientAdvSearch.length <= 0) {
            client();
        }

        else {

            console.log('handle search')

            setLoaderEnable(true)

            const token = localStorage.getItem("token")
            const userid = localStorage.getItem("userId")

            if (flagggg === "normalsearch") {
                setIsLoading(true)
            }
            let urlLink;

            urlLink = `${lambda}/clients?appname=${appname}&userid=${userid}${clientmanagesearch ? `&search=${clientmanagesearch}` : ''}&token=${token}`;

            // urlLink = lambda + '/clients?appname=' + appname + "&token=" + token + "&userid=" + userid

            // let payload = clientmanagesearch ? '' : { ...clientAdvSearch };

            const result = processObject(clientAdvSearch);
            // setClientAdvSearch(result)
            axios({
                method: 'POST',
                url: urlLink,
                // data: payload,
                data: result,
            })
                .then(function (response) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        setIsLoading(false)
                        setShowPopup(false)
                    } else {
                        // console.log("response", response);
                        setData(response?.data?.result?.data);
                        global.exportExcelData = response?.data?.result?.data
                        setContent(response?.data?.result);
                        setIsLoading(false);
                        setShowPopup(false)
                        setLoaderEnable(false);
                        if (flagggg === "click") {
                            setClientMangeSearch("")
                        }
                    }
                }).catch((err) => {
                    console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }


    const handleChange = (e) => {
        if (e.target.value === "") {
            //client();
            setFlag(false)
        }
        setClientMangeSearch(e.target.value)
    }

    const handleKeypress = (e) => {
        GetTimeActivity()
        //it triggers by pressing the enter key

        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };

    const handleEditClient = (e, paramuserid) => {
        console.log('paramuserid', paramuserid)
        GetTimeActivity()
        navigate("/editclient/" + paramuserid);
    }
    const handleDelete = (Id) => {
        console.log("Iddddddddddddddddddddddd", Id)
        setClientId(Id)
        setIsDelete(true)
    }
    const handleCancel = () => {
        setIsDelete(false)
    }
    const handleDeleteClient = () => {

        GetTimeActivity()
        setDeleteLoader(true)









        let payload = {

            "status": "ARCHIVE"
        };

        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        axios.post(lambda + '/updateClient?appname=' + appname + '&userId=' + userid + "&token=" + token + '&clientid=' + clientId, payload,)
            // "&token=" + token 
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        client()
                        setDeleteLoader(false)
                        setIsDelete(false)
                        // setIsLoading(false);
                        // setToastMessage("Client Details Updated Successfully")
                        // setToastType("success")
                        // setFollowupText("");
                        // setClientFlag(true)
                    }
                }
            }).catch((err) => {
                // setIsLoading(false);
                console.log('errr', err)
            });

        // }

    }
    const handleClose = () => [
        setIsDelete(false)
    ]
    const handleViewClient = (e, paramuserid) => {
        GetTimeActivity()
        navigate("/viewclient/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()
        setClientMangeSearch("");
        setClientAdvSearch({})
        client();
    }


    const clearadvSearch = () => {
        GetTimeActivity()
        setClientAdvSearch({ ...clientAdvSearch, businessname: "", emailId: "", contactname: "", subscription: "", type: "", created: "", status: "" })
    }
    const handleAdvChange = (e) => {
        const { name, value } = e.target;
        GetTimeActivity()
        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = clientAdvSearch?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setClientAdvSearch(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }
        setClientAdvSearch({ ...clientAdvSearch, [name]: value });
    }

    console.log('clientAdvanedSearch-------------------------->', clientAdvSearch)
    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No clients were found for the searched keyword</p>
                </div> </div>
        )
    }


    // console.log("current page", currentPageNew);
    // function compareHeaders(headers, actualHeaders) {
    //     let mismatches = [];

    //     headers.forEach((header, index) => {
    //         let actualHeader = actualHeaders[index];

    //         if (!actualHeader) {
    //             mismatches.push({ index, expected: header, found: "MISSING" });
    //         } else if (header.trim() !== actualHeader.trim()) {
    //             mismatches.push({ index, expected: header, found: actualHeader });
    //         }
    //     });

    //     actualHeaders.slice(headers.length).forEach((extraHeader, index) => {
    //         mismatches.push({ index: headers.length + index, expected: "EXTRA", found: extraHeader });
    //     });

    //     return mismatches;
    // }
    // const handleFiles = (event) => {
    //     var self = this;
    //     var file = event[0];
    //     var fileExt = file && file.name && file.name.split('.').pop();
    //     var reader = new FileReader();
    //     reader.onload = function (event) {
    //         let assetsData;
    //         let data = event.target.result;
    //         switch (fileExt) {
    //             case 'csv':
    //                 csv({})
    //                     .fromString(data)
    //                     .then((csvRows) => {
    //                         if (!csvRows || csvRows.length === 0) {
    //                             setPopupOpen(true);
    //                             setMessage("No data found in the file. Please upload a file that contains data.");
    //                             return;
    //                         }

    //                         const actualHeaders = Object.keys(csvRows[0]);
    //                         console.log('expectedHeaders', expectedHeaders)
    //                         console.log('actualHeaders', actualHeaders)

    //                         const headersMatch = compareHeaders(expectedHeaders, actualHeaders);
    //                         console.log('headersMatch', headersMatch);

    //                         if (headersMatch?.length > 0) {
    //                             setHeaders(headersMatch);
    //                             setPopupOpen(true);
    //                             setMessage("Invalid file format. Please ensure the headers are correct.");
    //                             return;
    //                         }

    //                         assetsData = csvRows;
    //                         console.log("csvRow", assetsData);
    //                         handleDisplay(assetsData);
    //                     });
    //                 break;
    //             case 'xlsx':
    //             case 'xls':
    //                 let workbook = XLSX.read(data, { type: "binary" });

    //                 const expectedHeaders = uploadFilesJson?.[0].headers;
    //                 console.log('expectedHeaders', expectedHeaders)
    //                 const sheetName = workbook.SheetNames[0];
    //                 const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

    //                 let actualHeaders = worksheet[0]
    //                 console.log('actualHeaders', actualHeaders)

    //                 const headersMatch = compareHeaders(expectedHeaders, actualHeaders)


    //                 console.log('headersMatch', headersMatch)


    //                 if (headersMatch?.length > 0) {
    //                     setHeaders(headersMatch)
    //                     setPopupOpen(true);
    //                     setMessage("Invalid file format. Please ensure the headers are correct.");

    //                     return; // Exit if headers don't match
    //                 } else {
    //                     // Check if there are rows after the header
    //                     if (worksheet.length <= 1) {

    //                         setPopupOpen(true);
    //                         setMessage("No data Found in the file. Please upload a file that contains data.");

    //                         return;
    //                     } else {
    //                         console.log("XLSXelsss")
    //                         // const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
    //                         //     header: headers, // Dynamically set headers
    //                         //     range: 1, // Skip the first row (header row)
    //                         //     defval: "" // Set empty values to empty strings instead of undefined
    //                         // });

    //                         // // Print extracted JSON data
    //                         // console.log("Processed JSON data:", jsonData);
    //                         // handleDisplay(assetsData)

    //                         workbook.SheetNames.forEach(sheet => {
    //                             assetsData = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
    //                             console.log("XLSX", assetsData)
    //                             // self.setState({ loader: true, fileType: fileExt });
    //                             handleDisplay(assetsData)
    //                         });

    //                     }
    //                 }


    //                 break;
    //             case 'json':
    //                 assetsData = data;
    //                 console.log("json", assetsData)
    //                 // self.setState({ loader: true, fileType: fileExt });
    //                 // self.handleDisplay(assetsData)
    //                 break;

    //         }
    //     };
    //     if (fileExt == 'json') {
    //         reader.readAsText(file);
    //     } else {
    //         reader.readAsBinaryString(file);
    //     }
    // }
    // const handleDisplay = (assetsList) => {

    //     //  console.log("importAsset", importAsset)
    //     if (assetsList && assetsList.length > 0) {
    //         let userid = localStorage.getItem("userid") || localStorage.getItem("userId")
    //         const urlLink = lambda + '/clientImport?appname=' + appname + (userid ? "&userid=" + userid : "");
    //         axios({
    //             method: 'POST',
    //             url: urlLink,
    //             data: assetsList
    //         })
    //             .then(function (response) {
    //                 if (response?.data?.statusCode == 200 && response?.data?.result?.failedCount > 0) {
    //                     console.log("response?.data?.result?.failedForms ", response?.data?.result?.failedForms)
    //                     setErrorPopup(true)
    //                     setErrorData(response?.data?.result?.failedForms)
    //                 } else if (response?.data?.statusCode == 200 && response?.data?.result) {
    //                     //history.push("./yellowForm");
    //                     setData(response.data.result && response.data.result)
    //                     setImportSuccess(true)
    //                     // GetPropertyData()
    //                 }
    //             });
    //     } else {
    //         setImportFailed(true)
    //     }

    // }

    const compareHeaders = (headers, actualHeaders) => {
        let mismatches = [];

        headers.forEach((header, index) => {
            let actualHeader = actualHeaders[index];
            if (!actualHeader) {
                mismatches.push({ index, expected: header, found: "MISSING" });
            } else if (header.trim() !== actualHeader.trim()) {
                mismatches.push({ index, expected: header, found: actualHeader });
            }
        });

        actualHeaders.slice(headers.length).forEach((extraHeader, index) => {
            mismatches.push({ index: headers.length + index, expected: "EXTRA", found: extraHeader });
        });

        return mismatches;
    };

    const handleFiles = (event) => {
        const file = event[0];
        const fileExt = file && file.name?.split('.').pop();
        const reader = new FileReader();

        reader.onload = function (event) {
            let assetsData;
            const data = event.target.result;
            const expectedHeaders = uploadFilesJson?.[0]?.headers;

            switch (fileExt) {
                case 'csv':
                    csv({})
                        .fromString(data)
                        .then((csvRows) => {
                            if (!csvRows || csvRows.length === 0) {
                                setPopupOpen(true);
                                setMessage("No data found in the file. Please upload a file that contains data.");
                                return;
                            }

                            const actualHeaders = Object.keys(csvRows[0]);
                            const headersMatch = compareHeaders(expectedHeaders, actualHeaders);

                            if (headersMatch.length > 0) {
                                setHeaders(headersMatch);
                                setPopupOpen(true);
                                setMessage("Invalid file format. Please ensure the headers are correct.");
                                return;
                            }

                            assetsData = csvRows;
                            handleDisplay(assetsData);
                        });
                    break;

                case 'xlsx':
                case 'xls':
                    const workbook = XLSX.read(data, { type: "binary" });
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

                    const actualHeaders = worksheet[0];
                    const headersMatch = compareHeaders(expectedHeaders, actualHeaders);

                    if (headersMatch.length > 0) {
                        setHeaders(headersMatch);
                        setPopupOpen(true);
                        setMessage("Invalid file format. Please ensure the headers are correct.");
                        return;
                    }

                    if (worksheet.length <= 1) {
                        setPopupOpen(true);
                        setMessage("No data Found in the file. Please upload a file that contains data.");
                        return;
                    }

                    workbook.SheetNames.forEach(sheet => {
                        assetsData = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
                        handleDisplay(assetsData);
                    });
                    break;

                case 'json':
                    assetsData = JSON.parse(data);
                    handleDisplay(assetsData);
                    break;
            }
        };

        if (fileExt === 'json') {
            reader.readAsText(file);
        } else {
            reader.readAsBinaryString(file);
        }
    };

    const handleDisplay = (assetsList) => {
        if (assetsList && assetsList.length > 0) {
            const userid = localStorage.getItem("userid") || localStorage.getItem("userId");
            const urlLink = `${lambda}/clientImport?appname=${appname}${userid ? `&userid=${userid}` : ""}`;

            axios.post(urlLink, assetsList)
                .then((response) => {
                    const result = response?.data?.result;
                    if (response?.data?.statusCode === 200 && result?.failedCount > 0) {
                        setErrorPopup(true);
                        setErrorData(result.failedForms);
                    } else if (response?.data?.statusCode === 200 && result) {
                        // setData(result);
                        setImportSuccess(true);
                    }
                });
        } else {
            setImportFailed(true);
        }
    };

    const onConfirm = () => {
        setImportSuccess(false)
        getclient()
    }

    const getclient = (e) => {
        console.log('client call')
        GetTimeActivity()
        let page = 1;
        //  setCurrentPage(1);
        setIsLoading(true);
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + '/clients?appname=' + appname + "&userid=" + userid + "&token=" + token,
        })
            .then(function (response) {
                // console.log("response", response?.data?.result?.data);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setData(response?.data?.result?.data);
                    global.exportExcelData = response?.data?.result?.data

                    setContent(response?.data?.result);
                    setIsLoading(false);
                    setClientMangeSearch("");
                    setSearchedFlag(false);
                }

            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }
    const errorClick = (e) => {
        setErrorPopup(false)
        getclient()
    }
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header id="header" />
                <Sidebar id="sidebar" />

                <div className="main-content user-management clients" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12" id="client-md-12">
                                    <div className="d-flex justify-content-between align-items-center" id="client-align-items-center">
                                        <h4 className="mb-0 card-title" id="breadcrumb-title">CLIENTS</h4>

                                        {subValDashboard?.add?.display === true && (
                                            <div className="d-flex flex-wrap gap-2 align-items-center">
                                                {uploadFilesJson?.map((item, idx) => (
                                                    <a
                                                        key={idx}
                                                        className="fill-btn-style ancor-btn-style"
                                                        href={item.downloadtemplate}
                                                        download={item.name}
                                                        id={`download-sample-template-${idx}`}
                                                    >
                                                        <span className="material-symbols-outlined icon">download</span>
                                                        Download Sample Template
                                                    </a>
                                                ))}

                                                <ReactFileReader
                                                    handleFiles={(e) => handleFiles(e)}
                                                    fileTypes={[".xlsx", ".xls", ".csv", ".json"]}
                                                >
                                                    <button type="button" className="stroke-btn-style" id="import-file-btn">
                                                        <span className="material-symbols-outlined">south_west</span>
                                                        Import
                                                    </button>
                                                </ReactFileReader>

                                                <button
                                                    onClick={handleAdd}
                                                    className={`fill-btn-style ${subValDashboard.add.enable === true ? "" : "pe-none"
                                                        }`}
                                                    id="add-client-btn"
                                                >
                                                    Add Client
                                                </button>
                                            </div>

                                        )}
                                    </div>
                                </div>
                                {/* <p className="text-muted m-0 justify-content-end d-flex mt-1">Supported files: <code>.xlsx</code>, <code>.csv</code></p> */}
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            <div className="row mb-2" id="table-header-row">
                                                <div className="col-sm-4 button-block" id="button-block">
                                                    <div className="dataTables_length" id="datatable-length">
                                                        {subValDashboard && subValDashboard.export && subValDashboard.export.display === true &&
                                                            <button
                                                                className={`fill_btn ${data?.length <= 0 || subValDashboard.export.enable === false ? 'disable pe-none' : ''}`}
                                                                onClick={handleExport}
                                                                id="export-btn">
                                                                <span className="material-icons">north_east</span>Export
                                                            </button>}


                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block" id="search-box">
                                                        <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={clientmanagesearch}
                                                                onChange={(e) => handleChange(e)}
                                                                onKeyPress={handleKeypress}
                                                                placeholder="Search by Name or Email"
                                                                id="search-input"
                                                            />
                                                            <button
                                                                className="fill_btn"
                                                                onClick={(e) => handleSearch(e, "normalsearch")}
                                                                id="search-btn">
                                                                <span className="material-icons search-icon">search</span>
                                                            </button>
                                                        </div>
                                                        <div className="dataTables_length" id="advancedsearch-btn">
                                                            <button className="fill_btn" onClick={handleShowPopup}>Advanced Search</button>

                                                        </div>
                                                        <div className="dataTables_length" id="client-reset-btn">
                                                            <button
                                                                className="fill_btn"
                                                                onClick={clearSearch}
                                                                id="reset-btn">
                                                                <span className="material-icons-outlined">sync</span>Reset
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <DataTable
                                                key={keyForRerender}
                                                columns={columns}
                                                keyField="_id"
                                                data={Array.isArray(data) ? data : []} // ✅ Ensures data is an array
                                                direction="auto"
                                                highlightOnHover
                                                fixedHeaderScrollHeight="300px"
                                                pagination
                                                responsive
                                                persistTableHead
                                                striped
                                                subHeaderAlign="right"
                                                defaultSortField="name"
                                                noDataComponent={customNoRecords()}
                                                paginationTotalRows={Array.isArray(data) ? data.length : 0} // ✅ Safe fallback
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}
                                                progressPending={isLoading}
                                                progressComponent={<TableLoader />}
                                                id="data-table"
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <Modal
  className="advance-search search-popup client-advance-search"
  show={popup}
  onHide={handleClosePopup}
  backdrop="static"
  id="advanced-search-modal"
>
  <Modal.Header closeButton id="advanced-search-modal-header">
    <Modal.Title id="advanced-search-modal-title">Advanced Search</Modal.Title>
  </Modal.Header>

  <Modal.Body id="advanced-search-modal-body">
    <div className="row" id="advanced-search-row">
      
      <div className="col-md-6" id="advanced-businessname-field">
        <div className="input-field" id="advanced-businessname-input-wrapper">
          <label className="col-form-label" id="advanced-businessname-label">BUSINESS NAME</label>
          <input
            className="form-control"
            placeholder="Enter Name"
            type="text"
            name="businessname"
            value={clientAdvSearch.businessname}
            onChange={(e) => handleAdvChange(e)}
            id="advanced-businessname-input"
          />
        </div>
      </div>

      <div className="col-md-6" id="advanced-contactname-field">
        <div className="input-field" id="advanced-contactname-input-wrapper">
          <label className="col-form-label" id="advanced-contactname-label">CONTACT NAME</label>
          <input
            className="form-control"
            placeholder="Enter Name"
            type="text"
            name="contactname"
            value={clientAdvSearch.contactname}
            onChange={(e) => handleAdvChange(e)}
            id="advanced-contactname-input"
          />
        </div>
      </div>

      <div className="col-md-6" id="advanced-email-field">
        <div className="input-field" id="advanced-email-input-wrapper">
          <label className="col-form-label" id="advanced-email-label">EMAIL</label>
          <input
            className="form-control contact-number"
            name="emailId"
            type="email"
            placeholder="Enter Email"
            value={clientAdvSearch.emailId}
            onChange={(e) => handleAdvChange(e)}
            id="advanced-email-input"
          />
        </div>
      </div>

      <div className="col-md-6" id="advanced-subscription-field">
        <div className="input-field" id="advanced-subscription-input-wrapper">
          <label className="col-form-label" id="advanced-subscription-label">SUBSCRIPTION</label>
          <select
            className="form-select"
            name="subscription"
            value={clientAdvSearch.subscription}
            onChange={(e) => handleAdvChange(e)}
            id="advanced-subscription-select"
          >
            <option value="">Select Plans</option>
            {subscriptionsData && subscriptionsData.map((plan) => (
              <option key={plan?.planname} value={plan?.planname?.toLowerCase()}>
                {plan?.planname}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="col-md-6" id="advanced-createdon-field">
        <div className="input-field" id="advanced-createdon-input-wrapper">
          <label className="col-form-label" id="advanced-createdon-label">Created On</label>
          <input
            id="advanced-createdon-input"
            name="created"
            placeholder="mm-dd-yyyy"
            type="date"
            className="form-control"
            value={clientAdvSearch.created}
            onChange={(e) => handleAdvChange(e)}
            max={new Date().toISOString().split('T')[0]}
          />
        </div>
      </div>

      <div className="col-md-6" id="advanced-status-field">
        <div className="input-field" id="advanced-status-input-wrapper">
          <label className="col-form-label" id="advanced-status-label">Status</label>
          <select
            className="form-select"
            name="status"
            value={clientAdvSearch.status}
            onChange={(e) => handleAdvChange(e)}
            id="advanced-status-select"
          >
            <option value="">Select Status</option>
            <option value="PENDING VERIFICATION">Pending Verification</option>
            <option value="INACTIVE">Inactive</option>
            <option value="ACTIVE">Active</option>
          </select>
        </div>
      </div>

    </div>
  </Modal.Body>

  <Modal.Footer id="advanced-modal-footer">
    <div className="adv_footer" id="advanced-footer">
      <button
        className="fill_btn yellow-gradient reset-btn"
        onClick={clearadvSearch}
        id="advanced-reset-btn"
      >
        <span className="material-icons-outlined">sync</span>Reset
      </button>

      <button
        onClick={(e) => handleSearch(e, "click")}
        id="advanced-search-btn"
      >
        {loaderEnable ? (
          <img
            src={`${image}${appname}/images/web/rotate_right.svg`}
            className="loading-icon"
            alt="loading"
          />
        ) : null}
        SEARCH
      </button>

      <div className="clearfix"></div>
    </div>
  </Modal.Footer>
</Modal>



                    <Modal className="new-set-modal" show={isDelete}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content rounded-4">

                                {/* Modal Header */}
                                <div className="modal-header border-0 justify-content-center position-relative">
                                    <button className="close-btn" onClick={e => handleClose()} id="client-delete-close-btn">
                                        <span className="material-icons">close</span>
                                    </button>
                                </div>

                                {/* Modal Body */}
                                <div className="modal-body text-center" id="client-delete-body">
                                    <img
                                        src={`${image}${appname}/images/web/disco-ball.gif`}
                                        alt="Delete Icon"
                                        className=""
                                        style={{ width: "100px", height: "100px" }}
                                        id="client-delete-icon"
                                    />
                                    <h3 className="modal-sm-heading" id="client-delete-title">Delete</h3>
                                    <p className="modal-text" id="client-delete-text">
                                        The changes cannot be undone.<br />
                                        Do you want to delete?
                                    </p>
                                </div>

                                {/* Modal Footer */}
                                <div className="modal-footer border-0 justify-content-center gap-3 pb-4">
                                    <button className="stroke-btn-style" onClick={handleCancel} id="client-dont-delete-btn">
                                        Don’t Delete
                                    </button>
                                    <button className="fill-btn save_continue" onClick={handleDeleteClient} id="client-confirm-delete-btn">
                                        {deleteLoader ? (
                                            <img
                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                className="loading-icon"
                                                alt="Loading"
                                                id="client-delete-loader"
                                            />
                                        ) : null}
                                        Yes, Delete
                                    </button>
                                </div>

                            </div>
                        </div>
                    </Modal>

                    <Modal className="advance-search search-popup" show={isPopupOpen} onHide={() => setPopupOpen(false)} backdrop="static">
                        <Modal.Header closeButton id="header-error-list">
                            <Modal.Title>Errors List</Modal.Title>
                        </Modal.Header>
                        <Modal.Body id="body-error-list">
                            {headersFound?.length > 0 && (
                                <div className="table-container">
                                    <div className="table-wrapper">
                                        <table className="table table-bordered" id="client-error-table">
                                            <thead>
                                                <tr className="title_header">
                                                    <th>Index</th>
                                                    <th>Expected</th>
                                                    <th>Actual</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {headersFound.map((eachItem, key) => (
                                                    <tr key={key}>
                                                        <td>{eachItem?.index}</td>
                                                        <td>{eachItem?.expected}</td>
                                                        <td>{eachItem?.found}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>

                    <Modal className="advance-search search-popup" show={isErrorPopup} onClick={() => errorClick()} backdrop="static">
                        <Modal.Header closeButton id="header-failed-list">
                            <Modal.Title>Failed List</Modal.Title>
                        </Modal.Header>
                        <Modal.Body id="body-failed-list">
                            {errorData?.length > 0 && (
                                <div className="table-container">
                                    <div className="table-wrapper">
                                        <table className="table table-bordered" id="client-failed-table">
                                            <thead>
                                                <tr className="title_header">
                                                    <th>Email Id</th>
                                                    <th>Phone Number</th>
                                                    <th>Reason</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {errorData.map((eachItem, key) => (
                                                    <tr key={key}>
                                                        <td>{eachItem?.item?.emailId || "N/A"}</td>
                                                        <td>{eachItem?.item?.phone || "N/A"}</td>
                                                        <td>{eachItem?.item?.reason}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title="Something went wrong. Please reload again."
                        onConfirm={() => setTableErrMsg(false)}
                        id="client-sweetalert-table-error"
                    />

                    {importSuccess && (
                        <SweetAlert
                            show={importSuccess}
                            custom
                            confirmBtnText="Ok"
                            confirmBtnBsStyle="primary"
                            title="Client Imported Successfully"
                            onConfirm={() => onConfirm()}
                            id="client-import-success-alert"
                        />
                    )}

                    <SweetAlert
                        show={importFailed}
                        custom
                        confirmBtnText="Ok"
                        confirmBtnBsStyle="error"
                        title="No Data Found"
                        onConfirm={() => setImportFailed(false)}
                        id="client-import-failed-alert"
                    />

                    <Footer id="client-footer" />

                </div>
            </div>

        </>
    );
};

export default Client;
